// 判断是否是双单
function doubleSingle(code: number) {
  return code % 2 === 0;
}

// 判断龙虎
function dragonOrTiger(code1: number, code2: number) {
  return code1 > code2 ? "龙" : code1 === code2 ? "和" : "虎";
}

/** 判断总数大小
 * @param result
 * @param target 判断基准点
 * @returns {string} 大 | 小
 */
export function allBigSmall(result: number[], target: number): string {
  const sum = allSum(result);
  return sum > target ? "大" : "小";
}

function shunzi(arr: number[]) {
  if (!arr) {
    return false;
  }
  const sorted = [...arr].sort((a, b) => a - b);
  const join = sorted.join("");
  if (join === "019" || join === "089") {
    return true;
  }
  let numberOfGap = 0;
  for (let i = 1; i < sorted.length; i++) {
    const gap = sorted[i] - sorted[i - 1];
    if (gap === 0) {
      return false;
    }
    if (gap > 1) {
      numberOfGap += gap - 1;
    }
  }
  return numberOfGap <= 0;
}

// 半顺
function banshun(arr: number[]) {
  if (!arr) {
    return false;
  }
  const sorted = [...arr].sort((a, b) => a - b);
  const join = sorted.join("");
  if (join === "019" || join === "089") {
    return false;
  }
  if (
    sorted[0] === 0 &&
    sorted[2] === 9 &&
    sorted[1] !== 1 &&
    sorted[1] !== 8
  ) {
    return true;
  }
  let numberOfConnect = 0;
  for (let i = 1; i < sorted.length; i++) {
    const gap = sorted[i] - sorted[i - 1];
    if (gap === 0) {
      return false;
    }
    if (gap <= 1) {
      numberOfConnect++;
    }
  }
  return numberOfConnect === 1;
}

function baozi(arr: number[]) {
  if (!arr) {
    return false;
  }
  const sorted = [...arr].sort((a, b) => a - b);
  let numberOfGap = 0;
  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i] - sorted[i - 1] === 0) {
      numberOfGap++;
    }
  }
  return numberOfGap === sorted.length - 1;
}

function duizi(arr: number[]) {
  if (!arr) {
    return false;
  }
  const sorted = [...arr].sort((a, b) => a - b);
  let numberOfGap = 0;
  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i] - sorted[i - 1] === 0) {
      numberOfGap++;
    }
  }
  return numberOfGap === sorted.length - 2;
}

// 六合彩总和
export function markSixSum(result: number[]) {
  if (result.length > 6) {
    const firstSixElements = result.slice(0, 6);
    return firstSixElements.reduce(
      (sum, value) => sum + Number.parseInt(String(value), 10),
      0,
    );
  }
  return 0;
}

// 总和大小
export function markSixBigSmall(result: number[]) {
  const resultCode = markSixSum(result);
  return resultCode >= 150 ? "总大" : "总小";
}

// 获取总和单双
export function markSixDoubleSingle(result: number[]) {
  const resultCode = markSixSum(result);
  return resultCode % 2 === 0 ? "总双" : "总单";
}

// 获取特码大小
export function markSixSpecialBigSmall(result: number[]) {
  if (result.length === 7) {
    const code = result[6];
    return code === 49 ? "和" : code >= 25 ? "大" : "小";
  }
  return "";
}

// 获取特码单双
export function markSixSpecialDoubleSingle(result: number[]) {
  if (result.length === 7) {
    const code = result[6];
    return code === 49 ? "和" : code % 2 === 0 ? "双" : "单";
  }
  return "";
}

// 特码合大、合小
export function markSixHeDaXiao(result: number[]) {
  if (result.length === 7) {
    const code = result[6];
    const low = code % 10;
    const high = Math.floor(code / 10);
    return code === 49 ? "和" : low + high >= 7 ? "合大" : "合小";
  }
  return "";
}

export function markSixHeDanShuang(result: number[]) {
  if (result.length === 7) {
    const code = result[6];
    const low = code % 10;
    const high = Math.floor(code / 10);
    return code === 49 ? "和" : (low + high) % 2 === 0 ? "合双" : "合单";
  }
  return "";
}

export function markSixWeiDaXiao(result: number[]) {
  if (result.length === 7) {
    const code = result[6];
    const wei = code % 10;
    return code === 49 ? "和" : wei >= 5 ? "尾大" : "尾小";
  }
  return "";
}

// PK10获取那个位置的龙虎
export function pktenDragonTiger(result: number[], index?: number) {
  if (result.length !== 10) {
    return "";
  }
  if (index === 1) {
    return dragonOrTiger(result[0], result[9]);
  }
  if (index === 2) {
    return dragonOrTiger(result[1], result[8]);
  }
  if (index === 3) {
    return dragonOrTiger(result[2], result[7]);
  }
  if (index === 4) {
    return dragonOrTiger(result[3], result[6]);
  }
  if (index === 5) {
    return dragonOrTiger(result[4], result[5]);
  }
  return "";
}

// 所有总和
export function allSum(result: number[]) {
  return result.reduce((a: number, b: number) => a + b, 0);
}

// 所有总和的单双
export function alldoubelSingle(result: number[]) {
  const sum = allSum(result);
  const isDouble = doubleSingle(sum);
  return isDouble ? "双" : "单";
}
//分分彩单球的大小 >=5是大 否则是小
export function minutLottoSingleBigSmall(ball: number) {
  return ball >= 5 ? "大" : "小";
}

// 分分彩龙虎
export function minutLettoDragTiger(result: number[]) {
  return dragonOrTiger(result[0], result[4]);
}

// 1是前三，2是中三，3是后三
export function calcLotteryThreeBalls(result: number[], index?: number) {
  let array: number[] = [];
  if (index === 1) {
    array = result.slice(0, 3);
  }
  if (index === 2) {
    array = result.slice(1, 4);
  }
  if (index === 3) {
    array = result.slice(2, 5);
  }
  if (shunzi(array)) {
    return "顺子";
  }
  if (banshun(array)) {
    return "半顺";
  }
  if (baozi(array)) {
    return "豹子";
  }
  if (duizi(array)) {
    return "对子";
  }
  return "杂六";
}

// 快三大小 当结果为豹子时候不能显示
export function threeDiceBigSmall(result: number[]) {
  const sum = allSum(result);
  const array = result.slice(0, 3);
  if (baozi(array)) {
    return "-";
  }
  return sum > 10 ? "大" : "小";
}

// 快三双单 当结果为豹子时候不能显示
export function threeDictDoubleSingle(result: number[]) {
  const array = result.slice(0, 3);
  const sum = allSum(result);
  if (baozi(array)) {
    return "-";
  }
  const isDouble = doubleSingle(sum);
  return isDouble ? "双" : "单";
}

export function guanYaSum(result: number[]) {
  if (result.length >= 2) {
    return result[0] + result[1];
  }
  return 0;
}
export function guanYaBigSmall(result: number[]): string {
  const sum = guanYaSum(result);
  return sum > 11 ? "大" : "小";
}

export function guanYaDoubleSingle(result: number[]): string {
  const sum = guanYaSum(result);
  return sum % 2 === 0 ? "双" : "单";
}
